import { render } from "./checkout_pendente.vue?vue&type=template&id=5ce87dd8"
import script from "./checkout_pendente.vue?vue&type=script&lang=js"
export * from "./checkout_pendente.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__